export default __webpack_public_path__ + "static/media/Padron_ChurchillClosed.89a0bc15.jpg";